module.exports = __webpack_public_path__ + "img/van-icon.ac2f1c3e.png";